import React, { memo } from 'react';
import { interpolate } from '@vmos2/core';
import { CardText } from '@vmos2/design-system';
import { itemTotalPrice, usePriceFormat } from '@vmos2/price';
import type { BundleItem } from 'flow-types';

type Props = {
	items: BundleItem[],
	isTakeAway: boolean,
};

/* eslint react/prop-types: "warn" */
export const ItemsDisclaimer = memo(({ items, isTakeAway }: Props) => {
	const format = usePriceFormat();
	return items
		.map(item => {
			const text = item.disclaimers?.find(disclaimer => disclaimer.type === 'category_note')?.text;
			if (text) {
				const price = itemTotalPrice(item, isTakeAway);
				return interpolate(text, { price: format(price) });
			}
			return null;
		})
		.filter(Boolean)
		.map(disclaimer => <div><CardText>{disclaimer}</CardText></div>);
});
